import { render, staticRenderFns } from "./AddReceipt.vue?vue&type=template&id=4c353118"
import script from "./AddReceipt.vue?vue&type=script&lang=js"
export * from "./AddReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports